import React, { useState } from "react";
import "./Login.css";
import axiosIns from "./components/axiosIns";
import { Link } from "react-router-dom";
import { Alert } from "./components/Toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

function Login() {
  const [loginData, setData] = useState({
    email: "",
    password: "",
    role: 1,
  });
  const { email, password, role } = loginData;
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setData({ ...loginData, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = { email: email, password: password, role: role };
    await axiosIns
      .post("/sign_in", data)
      .then((res) => {
        if (res.data.status === true) {
          localStorage.setItem("isLogin", true);
          localStorage.setItem("token", res.data.data.userToken);
          localStorage.setItem("id", res.data.data.ID);
          localStorage.setItem("name", res.data.data.Name);
          localStorage.setItem("role", res.data.data.Role);

          const expirationTime = Date.now() + res.data.data.expiresIn * 43500;
          localStorage.setItem("tokenExpirationTime", expirationTime);
          Alert("succ", res.data.msg);
          window.open("https://www.admin.aganhealthcare.com");
        } else console.log(res.data.msg);
        Alert("error", res.data.msg);
      })
      .catch((err) => {
        console.log(err);
        Alert("error", err);
      });
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="app">
      <div className="login-form">
        <div className="title">Kaviyam Healthcare</div>
        <div className="form" style={{ width: "320px" }}>
          <form onSubmit={handleSubmit}>
            <div className="input-container">
              <input
                type="text"
                name="email"
                value={email}
                onChange={handleChange}
                placeholder="Enter Your Username/Email"
                required
              />
            </div>
            <div className="input-container">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={password}
                onChange={handleChange}
                placeholder="  Enter Your Password"
                required
              />
              <FontAwesomeIcon
                icon={showPassword ? faEyeSlash : faEye}
                className="password-icon"
                onClick={toggleShowPassword}
              />
            </div>
            <div className="forgot-password-container">
              <Link to="/forgot_password">Forgot Password?</Link>
            </div>
            <div className="button-container">
              <input type="Submit" />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
